import { useQuery } from '@tanstack/react-query';
import { USE_MOCK_DATA } from '@/lib/api';
import { fetchLibraryConfig } from '@/data/sources-library';

/** content_library_v1 (workspace setting, default OFF). OFF, loading or any error
 *  = today's Content screens, unchanged. ON = Library + Create · AI Studio. */
export function useContentLibraryFlag(): { enabled: boolean; isLoading: boolean } {
  const q = useQuery({
    queryKey: ['content-library-config'],
    queryFn: fetchLibraryConfig,
    enabled: !USE_MOCK_DATA,
    staleTime: 5 * 60_000,
    retry: false,
  });
  return { enabled: q.data?.contentLibraryV1 === true, isLoading: !USE_MOCK_DATA && q.isLoading };
}
